<template>
    <div class="faculties">
        <div class="row">
            <div class="filter-secition">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Fakülte Ara</label>
                        <div class="input-group">
                            <input class="form-control custom-input" type="text" placeholder="Fakülte Adı" v-model="search">
                            <span class="input-group-btn">
                                <a class="btn btn-primary" style="height: 45px;" @click="searchFilter">
                                    <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i> 
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Üniversite</label>
                        <select class="form-control custom-input" v-model="university" @change="universityFilter">
                            <option value="" selected hidden disabled>Seçiniz...</option>
                            <option v-for="university in universities" :key="university.id" :value="university.id">{{ university.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Fakülte</th>
                                        <th>Üniversite</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.university.name }}</td>
                                        <td>
                                            <router-link :to="{ name: 'faculties.update', params: {id: item.id} }" class="btn btn-primary btn-xs"><span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs"> Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    export default {
        components: { Pagination },
        data () {
            return {
                tableName: 'Fakülteler Tablosu',
                icon: 'fa fa-building',
                tableDesc: '',
                api: 'faculties',
                items: [],
                university: '',
                universities: [],
                search: '',
                pagination: {
                    'current_page': 1
                }
            }
        },
        mounted () {
            this.fetchPosts()
        },
        methods: {
            fetchPosts() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    page: this.pagination.current_page,
                    name: this.search,
                    university: this.university
                }}).then(response => {
                    this.pagination = response.data.pagination;
                    this.items = response.data.data.data
                    this.universities = response.data.universities
                    this.$Progress.finish()
                })
            },
            searchFilter() {
                this.$Progress.start()
                this.axios.get(this.api, {params: {
                    name: this.search
                }}).then(response => {
                    this.items = response.data.data.data
                    this.pagination = response.data.pagination;
                    this.$Progress.finish()
                })
            },
            universityFilter() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    university: this.university
                }}).then(response => {
                    this.items = response.data.data.data
                    this.pagination = response.data.pagination;
                    this.$Progress.finish()
                })
            }
        },
    }
</script>

<style scoped>

</style>